export const environment = {
    "envId": "b4cad844-6b02-dd26-ed93-d53d0c42aca6",
    "name": "prod",
    "properties": {
        "production": true,
        "baseUrl": "https://omni.multichoice.co.za/bhive-art/",
        "tenantName": "multichoice",
        "appName": "uopor",
        "namespace": "com.neutrinos.multichoice.uopor",
        "isNotificationEnabled": true,
        "googleMapKey": "AIzaSyCSTnVwijjv0CFRA4MEeS-H6PAQc87LEoU",
        "firebaseSenderId": "619180056844",
        "firebaseAuthKey": "AAAAkCoB4Qw:APA91bH2Atmju55QQslDMmrCQydTYj2JI8-SsI1zpggGjrNgPQSNBvld6Usklavc4B4o7OdbDfyrsTvXBTkaTU1yKAea0xRYiTVxzSpX3ue71LwKrj5lUzmP5Hnjfuw4c-atVY5JquhW",
        "authDomain": "AUTH_DOMAIN",
        "databaseURL": "DATABASE_URL",
        "storageBucket": "STORAGE_BUCKET",
        "messagingSenderId": "619180056844",
        "appDataSource": "multichoice-rt",
        "appAuthenticationStrategy": "localAuth"
    }
}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/environments/environment.ts